import React, { useCallback } from 'react'
import { TransformData } from 'react-admin'
import { SaveWithConfirmButton } from './SaveWithConfirmButton'
import { SaveWithConfirmButtonProps } from './type'

const PublishSaveButton: React.FC<SaveWithConfirmButtonProps> = ({
  encType = 'application/json',
  alwaysEnable = true,
  disabled: disabledProp = false,
  ...props
}) => {
  const transformApprove: TransformData = useCallback(
    (data) => ({ ...data, is_published: true, encType }),
    [encType],
  )
  return (
    <SaveWithConfirmButton
      label='ra.action.publish'
      confirmTitle='ra.message.confirmation.publish.title'
      confirmContent='ra.message.confirmation.publish.content'
      transform={transformApprove}
      icon={<></>}
      sx={{ color: 'white' }}
      variant='contained'
      type='button'
      color='success'
      encType={encType}
      alwaysEnable={alwaysEnable}
      disabled={disabledProp}
      {...props}
    />
  )
}

export default PublishSaveButton
